import React from 'react'
import styled, { css } from 'styled-components'
import Icon, { IconProps } from '../Icon'

export type SidebarButtonProps = {
  icon: IconProps['name']
  active?: boolean
}

const SidebarButton = styled.button.attrs<SidebarButtonProps>((props) => ({
  className: 'button',
  children: (
    <>
      <Icon name={props.icon} />
      <div>{props.children}</div>
    </>
  )
}))<SidebarButtonProps>`
  appearance: none;
  text-transform: none;
  display: flex;
  padding: 20px 20px;
  margin: 0;
  width: 100%;
  text-align: left;
  flex-direction: row;
  align-items: center;
  transition: color 0.2s;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    background: #cf0000;
    position: absolute;
    left: 0;
    top: 7px;
    bottom: 10px;
    width: 4px;
    transition: transform 0.2s;
    transform: translateX(-100%);
  }

  ${Icon} {
    margin: 0 15px;
    font-size: 20px;
    margin-top: -3px;
  }

  ${({ active }) =>
    active
      ? css`
          color: #cf0000;

          &::after {
            transform: translateX(0);
          }
        `
      : ''}
`

export default SidebarButton
